import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarPlus, AlertTriangle, RotateCcw, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// iter316 — "Needs Scheduling — Return Visit" card on the Unscheduled rail. Backed by the
// canonical db.job_return_actions record (one active per Job). Primary action = Add Return
// Visit (existing Add Visit to Existing Job flow — never a new Job).
export const ReturnVisitCard = ({ item, onAddReturnVisit, onChanged }) => {
  const dismiss = async (e) => {
    e.stopPropagation();
    const note = window.prompt('Resolve without scheduling a return visit? Add a short reason:');
    if (!note || !note.trim()) return;
    try {
      await axios.post(`${API}/admin/job-return-actions/${item.id}/dismiss`, { note }, { withCredentials: true });
      toast.success('Return visit action resolved');
      onChanged?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not resolve'); }
  };
  return (
    <div
      data-testid={`unsched-card-return_visit-${item.id}`}
      onClick={() => onAddReturnVisit?.(item)}
      role="button" tabIndex={0}
      className={`border-l-4 rounded-r-md p-2 cursor-pointer transition-colors hover:bg-[#1a1a1a] ${item.customer_promised ? 'border-l-amber-400 bg-amber-500/10' : 'border-l-sky-400 bg-sky-500/5'}`}
    >
      <div className="flex items-center gap-1.5 flex-wrap mb-1">
        <span className="text-[9px] font-bold uppercase tracking-wider text-sky-300 flex items-center gap-0.5"><RotateCcw className="w-2.5 h-2.5" /> Needs Scheduling — Return Visit</span>
        <span className="text-[9px] font-mono text-[#D4AF37]">{item.job_number}</span>
      </div>
      {item.customer_promised && (
        <p data-testid={`return-promised-${item.id}`} className="text-[10px] font-bold text-amber-300 flex items-center gap-1 mb-1">
          <AlertTriangle className="w-3 h-3" /> CUSTOMER PROMISED — {item.promised_label}
        </p>
      )}
      <p className="text-white text-xs font-medium">{item.customer_name}</p>
      {item.address && <p className="text-[#A3A3A3] text-[10px] line-clamp-1">{item.address}</p>}
      <p className="text-[#A3A3A3] text-[10px]">{[item.department_name, item.division, item.service_type].filter(Boolean).join(' · ')}</p>
      <p className="text-[#A3A3A3] text-[10px]">Last: {item.last_technician_name || '—'} · {item.last_visit_date || '—'}</p>
      <p data-testid={`return-reason-${item.id}`} className="text-sky-200 text-[10px] mt-0.5">{item.reason_label}{item.note ? ` — ${item.note}` : ''}</p>
      {item.suggested_label && <p className="text-[#A3A3A3] text-[10px]">Suggested: {item.suggested_label}</p>}
      <div className="flex items-center gap-1 mt-1.5">
        <button
          data-testid={`unsched-add-return-visit-${item.id}`}
          onClick={(e) => { e.stopPropagation(); onAddReturnVisit?.(item); }}
          className="flex-1 text-[10px] bg-sky-500/20 hover:bg-[#D4AF37] hover:text-[#0A0A0A] text-white rounded px-2 py-1 font-bold uppercase tracking-wider flex items-center justify-center gap-1"
        >
          <CalendarPlus className="w-3 h-3" /> Add Return Visit
        </button>
        <button data-testid={`unsched-dismiss-return-${item.id}`} onClick={dismiss} title="Resolve without scheduling" className="text-[10px] text-[#A3A3A3] hover:text-red-300 px-1.5 py-1">
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default ReturnVisitCard;
